import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import CMPFormInputText from '../../../../common/Forms/CMPFormTextField';
import CMPInputDropdown from '../../../../common/Forms/CMPInputDropdown';
import { useDispatch, useSelector } from 'react-redux';
import {
  setParticipant3,
  setParticipant6,
  setCss3,
  setCss6,
  setScss3,
  setScss6,
  setRvwDate3,
  setRvwDate6,
} from '../../../../../redux/episode/cmpTab/cmpForm/cmpSlice';

const Section3 = (props) => {
  const dispatch = useDispatch();
  const { control, defaultValue, register } = props;

  const cmpReferenceData = useSelector((state) => state.cmpReferenceData);

  const { firstParticipantList, participantList, cssOrScssList } = cmpReferenceData;

  return (
    <Grid item xs={12} sm={4}>
      <CMPInputDropdown
        name='participant3'
        control={control}
        options={firstParticipantList}
        defaultId={defaultValue?.participant3}
        register={register('participant3', {
          onChange: (e) => dispatch(setParticipant3(e.target.value)),
        })}
        label='Participant'
      />
      <CMPInputDropdown
        name='css3'
        control={control}
        options={cssOrScssList}
        defaultId={defaultValue?.css3}
        cssOrScssList={true}
        register={register('css3', {
          onChange: (e) => dispatch(setCss3(e.target.value)),
        })}
        label='Css'
      />
      <CMPInputDropdown
        name='scss3'
        control={control}
        options={cssOrScssList}
        defaultId={defaultValue?.scss3}
        cssOrScssList={true}
        register={register('scss3', {
          onChange: (e) => dispatch(setScss3(e.target.value)),
        })}
        label='Scss'
      />
      <CMPFormInputText
        name='rvwDate3'
        type='date'
        control={control}
        shrink={true}
        register={register('rvwDate3', {
          onBlur: (e) => dispatch(setRvwDate3(e.target.value)),
        })}
        label='Date'
      />
      <CMPInputDropdown
        name='participant6'
        control={control}
        options={firstParticipantList}
        defaultId={defaultValue?.participant6}
        register={register('participant6', {
          onChange: (e) => dispatch(setParticipant6(e.target.value)),
        })}
        label='Participant'
      />
      <CMPInputDropdown
        name='css6'
        control={control}
        options={cssOrScssList}
        defaultId={defaultValue?.css6}
        cssOrScssList={true}
        register={register('css6', {
          onChange: (e) => dispatch(setCss6(e.target.value)),
        })}
        label='Css'
      />
      <CMPInputDropdown
        name='scss6'
        control={control}
        options={cssOrScssList}
        defaultId={defaultValue?.scss6}
        cssOrScssList={true}
        register={register('scss6', {
          onChange: (e) => dispatch(setScss6(e.target.value)),
        })}
        label='Scss'
      />
      <CMPFormInputText
        name='rvwDate6'
        type='date'
        control={control}
        shrink={true}
        register={register('rvwDate6', {
          onBlur: (e) => dispatch(setRvwDate6(e.target.value)),
        })}
        label='Date'
      />
      <hr />
      <Box mt={2}>
        <CMPFormInputText
          name='phone'
          type='text'
          control={control}
          disabled={true}
          label='Phone'
        />
      </Box>
    </Grid>
  );
};

export default Section3;
